import useApartmentComplexSearch from 'api/hooks/use-apartment-complex-search';
import { useEffect, useState } from 'react';

const useComplex = (isFetch: boolean) => {
  const [selectedComplex, setSelectedComplex] = useState<number | null>(null);

  const {
    complexes,
    error: errorComplexes,
    isLoading: isLoadingComplexes,
    mutate,
  } = useApartmentComplexSearch('', true, isFetch);

  const handleSetComplex = (complex: number) => {
    setSelectedComplex(complex);
  };

  useEffect(() => {
    if (!complexes.length) {
      mutate();
    }
  }, [isFetch]);

  useEffect(() => {
    if (errorComplexes) {
      console.log(errorComplexes);
    }
  }, [errorComplexes]);

  const handleResetComplex = () => {
    setSelectedComplex(null);
  };

  return { selectedComplex, complexes, isLoadingComplexes, handleSetComplex, handleResetComplex };
};

export default useComplex;
